import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Home from '../containers/Home/Home';

function Routing() {

    return (
        <Router>
            <Switch>
                <Route path="/" exact>
                    <Home />
                </Route>
                {/* <Route path="/farms">
                    <Farms />
                </Route> */}
            </Switch>
        </Router>
    );
}

export default Routing;
